<script setup lang="ts">
const t2 = useT2({
  'Privacy policy': 'Privatumo politika',
})
const { seller } = useSeller('server')
</script>

<template>
  <AppMenu :title=" t2('Privacy policy')">
    <template #content>
      <DocumentUi :document-id="seller?.doc?.privacyPolicy?._id" />
    </template>
  </AppMenu>
</template>
